import { createAction, props } from "@ngrx/store";
import { Chapter } from "src/app/models/instruction/chapter";
import { ChapterConfirmation } from "src/app/models/instruction/chapter-confirmation";
import { Instruction } from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";
import { Answer, Question } from "src/app/models/question";

export const loadMyInstruction = createAction(
  "[Instruction] load my instruction",
  props<{
    name: string; // XXX: USELESS because we can infer the instruction from the instruction confirmation.  We leave it in for now as it's used very frequently down the line when loading chapters, etc...
    instructionConfirmation: string;
  }>(),
);

export const loadedMyInstruction = createAction(
  "[Instruction] loaded my instruction",
  props<{
    instruction: Instruction;
  }>(),
);

export const loadMyInstructionConfirmation = createAction(
  "[Instruction] load confirmation",
  props<{
    instructionConfirmation: string;
  }>(),
);

export const loadedMyInstructionConfirmation = createAction(
  "[Instruction] loaded confirmation",
  props<{
    confirmation?: InstructionConfirmation;
  }>(),
);

export const confirmChapterFailed = createAction(
  "[Instruction] confirm chapter failed",
  props<{
    error?: any;
  }>(),
);

export const loadChapters = createAction(
  "[Instruction] load chapters",
  props<{
    instruction: Instruction;
  }>(),
);

export const loadedChapters = createAction(
  "[Instruction] loaded chapters",
  props<{
    chapters: Chapter[];
  }>(),
);

export const loadChapterConfirmations = createAction(
  "[Instruction] load chapter confirmations",
  props<{
    instruction: string;
    instructionConfirmation: string;
  }>(),
);

export const loadedChapterConfirmations = createAction(
  "[Instruction] loaded chapter confirmations",
  props<{
    chapterConfirmations: ChapterConfirmation[];
  }>(),
);

export const selectChapter = createAction(
  "[Instruction] select chapter",
  props<{
    chapter: Chapter;
  }>(),
);

export const loadQuestionsForChapter = createAction(
  "[Instruction] load chapter questions for chapter",
  props<{
    chapter: string;
    instructionConfirmation: string;
  }>(),
);

export const loadedQuestionsForChapter = createAction(
  "[Instruction] loaded chapter questions for chapter",
  props<{
    questions: Question[];
  }>(),
);

export const confirmChapter = createAction(
  "[Instruction] confirm chapter",
  props<{
    chapter: Chapter;
    instructionConfirmation: InstructionConfirmation;
    answers: Answer[];
  }>(),
);

export const confirmedChapter = createAction(
  "[Instruction] confirmed chapter",
  props<{
    confirmation: ChapterConfirmation;
  }>(),
);
